module.exports = __webpack_public_path__ + "static/media/firstInvoiceIcon.ee8473d6.svg";